import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ChangedOptions, RegionsGroups } from '../../typings/log';
import {
    ExpandableCell,
    ExpandableProps
} from '../ExpandableCell/ExpandableCell';

import './RegionsCell.css';

export interface RegionsProps extends ExpandableProps {
    diff: RegionsGroups;
}

export class RegionsCell extends ExpandableCell<RegionsProps> {
    protected getContent() {
        return (
            <div
                className={Bem.cls('regions-cell')}
                ref={ref => (this.cell = ref)}
            >
                {this.getAdded()}
                {this.getRemoved()}
            </div>
        );
    }

    private getAdded = (): React.ReactNode => {
        const {
            diff: { after }
        } = this.props;

        return this.getRegion(after, ChangedOptions.added);
    };

    private getRemoved = (): React.ReactNode => {
        const {
            diff: { before }
        } = this.props;

        if (before.length > 0) {
            return this.getRegion(before, ChangedOptions.removed);
        }
        return '';
    };

    private getRegion = (value: string, type: string): React.ReactNode => {
        const { isExpanded, canExpand } = this.props;

        return (
            <div
                className={classNames(
                    Bem.cls('regions-cell', 'row'),
                    Bem.cls('regions-cell', type.toLowerCase()),
                    !isExpanded && canExpand
                        ? Bem.cls('expandable-cell', 'short-row')
                        : ''
                )}
            >
                {value}
            </div>
        );
    };
}
